export default function resolveParams<T extends Record<string, unknown> | undefined>(
  params: T,
  query: URLSearchParams
): T {
  if (!params) return {} as T;

  const temp: Record<string, unknown> = {};
  for (const [key, val] of Object.entries(params as Record<string, unknown>)) {
    if (val) {
      temp[key] = val;
    } else {
      temp[key] = query.get(key) || undefined;
    }
  }
  return temp as T;
}
